var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',[_c('div',{staticClass:"top-btn",attrs:{"data-io-click":"tracker"},on:{"click":_vm.handleScrollTop}},[_c('i',{staticClass:"iconfont icon-arrow-up-to-line"}),_c('span',[_vm._v("顶部")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }